/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "99DD36DA-C866-47CA-9A31-797D51616F27",
  "sitecoreApiHost": "https://Services.jumeirah.com",
  "jssAppName": "baa",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/BurjAlArab",
  "graphQLEndpoint": "https://Services.jumeirah.com/api/BurjAlArab?sc_apikey=99DD36DA-C866-47CA-9A31-797D51616F27"
};